import {useTranslation} from 'hooks/translations/useCustomTranslation';

import {FormControl, InputLabel, MenuItem, Select} from '@mui/material';

import {Group} from 'lib/api/backend.schemas';

import {palette} from 'styles/mui/scss';

import {CustomIcon} from 'components/basic-components/CustomIcon/CustomIcon';

import styles from './ResultCard.module.scss';

const PreferredVehicle = ({
  setSelectedVehicle,
  group,
  vehicle,
}: {
  group: Group;
  vehicle: string;
  setSelectedVehicle: (vehicle: string) => void;
}) => {
  const {t} = useTranslation('carlist');

  const handleChange = e => {
    setSelectedVehicle(e.target.value);
    e.stopPropagation();
  };

  return group?.vehicles?.length ? (
    <FormControl className={styles.preferredVehicleControl} variant="standard">
      <InputLabel
        sx={{'&.Mui-focused': {color: palette.colorGrey80}}}
        className={styles.preferredVehicleLabel}
        id="select-preferredVehicle"
      >
        {t('chooseDesiredVehicle')}
      </InputLabel>
      <Select
        className={styles.preferredVehicleSelect}
        labelId="select-preferredVehicle"
        value={vehicle}
        label={t('chooseDesiredVehicle')}
        onChange={handleChange}
        displayEmpty={true}
        onClose={e => e.stopPropagation()}
        MenuProps={{
          disableScrollLock: false,
          sx: {
            '&& .Mui-selected': {
              backgroundColor: 'rgba(254,237,1, 0.2)',
            },
          },
        }}
        IconComponent={() => <CustomIcon name="chevronDown" className={styles.icon} />}
      >
        {group.vehicles.map((vehicle, index) => {
          return (
            <MenuItem
              key={vehicle}
              onClick={e => e.stopPropagation()}
              value={vehicle}
              autoFocus={index === 0}
            >
              {vehicle}
            </MenuItem>
          );
        })}
      </Select>
    </FormControl>
  ) : null;
};
export default PreferredVehicle;
